/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createFormat } from '../../factoriesAny.js';
export var formatDependencies = {
  typedDependencies,
  createFormat
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesFormat.generated.js
// module id = raY8
// module chunks = 3